import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { priceList, updatePrice } from "../../apis/apisList/adminApi";
import { toast } from "react-toastify";
import { Alert } from "@mui/material";
import CustomLoader from "../CustomLoader";

const initialRows = [
  {
    id: 1,
    planName: "Image Plan",
    basePrice: 379,
    extraPrice: 5,
    max: 20,
  },
  {
    id: 2,
    planName: "Video Plan",
    basePrice: 250,
    extraPrice: 65,
    max: 0.5,
  },
  {
    id: 3,
    planName: "Photogrammetry",
    basePrice: 649,
    extraPrice: 7,
    max: 10,
  },
  {
    id: 3,
    planName: "LiDAR",
    basePrice: 699,
    extraPrice: 17,
    max: 10,
  },
];

export default function AdminPriceList() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleOpen = (row) => {
    setCurrentRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentRow(null);
  };

  const handleChange = (field, value) => {
    setCurrentRow((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    try {
      const { basePrice, extraPrice, max } = currentRow;
      await updatePrice(currentRow.id, {
        ...currentRow,
        basePrice: parseInt(basePrice),
        extraPrice: parseInt(extraPrice),
        max: parseInt(max),
      });
      setRows((prevRows) =>
        prevRows.map((row) => (row.id === currentRow.id ? currentRow : row))
      );
      toast.success("Price updated successfully");
      handleClose();
    } catch (error) {
      console.log("Error updating price:", error);
    }
  };
  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await priceList();
        setRows(response);
      } catch (error) {
        console.error("Error fetching prices:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPrices();
  }, []);

  return (
    <TableContainer
      component={Paper}
      sx={{
        width: "100%",
        overflowX: "auto",
        borderRadius: "10px",
        boxShadow: "none",
      }}
    >
      {loading ? (
        <CustomLoader loading={loading} />
      ) : (
        <Table
          sx={{
            width: "100%",
            "& thead": {
              backgroundColor: "#EBEBEB",
            },
            "& tbody": {
              backgroundColor: "#F8F8F8",
            },
            "& .MuiTableCell-root": {
              borderBottom: `1px solid #E0E0E0`,
            },
          }}
          aria-label="admin price table"
        >
          <TableHead>
            <TableRow>
              <TableCell>Plan Name</TableCell>
              <TableCell>Base Price ($)</TableCell>
              <TableCell>Max images/miles</TableCell>
              <TableCell>Extra Price ($)</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.planName}</TableCell>
                <TableCell>{row.basePrice}</TableCell>
                <TableCell>{row.max}</TableCell>
                <TableCell>{row.extraPrice}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<EditIcon />}
                    onClick={() => handleOpen(row)}
                  >
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit Plan</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            label="Base Price ($)"
            type="number"
            value={currentRow?.basePrice || ""}
            onChange={(e) => handleChange("basePrice", e.target.value)}
          />
          <TextField
            fullWidth
            margin="dense"
            label="Extra Price ($)"
            type="number"
            value={currentRow?.extraPrice || ""}
            onChange={(e) => handleChange("extraPrice", e.target.value)}
          />
          <TextField
            fullWidth
            margin="dense"
            label="Max images/miles"
            type="number"
            value={currentRow?.max || ""}
            onChange={(e) => handleChange("max", e.target.value)}
          />
        </DialogContent>
        <Alert severity="info">{currentRow?.info}</Alert>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </TableContainer>
  );
}
